import CardIcon from '@shared/components/core/card/CardIcon';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

export interface IOrgProductLandingProps {
    orgId: string;
}

export default function OrgProductLanding({ orgId }: IOrgProductLandingProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardIcon
            name="orgTransaction"
            title={t('common:license.key.product.titleLong')}
            description={t('common:license.key.product.description')}>
            <OrgLinks organizationId={orgId} variant={'orgProduct'} />
        </CardIcon>
    );
}
